var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.041 11.14c.142 0 .276.057.38.163l1.276 1.276a.54.54 0 0 1 0 .77l-1 1l-2.046-2.046l1-1a.57.57 0 0 1 .39-.163m-1.978 1.74l2.046 2.052L15.063 21H13v-2.063zM12 5.688l-5 4.5V18h4v2H5v-8H2l10-9l7.459 6.713L17 12.172v-1.984z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCms);
export default __webpack_public_path__ + "static/media/home_cms.030b83084d1f62c2aa1de5102329f619.svg";
export { ForwardRef as ReactComponent };